module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_7042.80f6de36.png";